import type { FaireProductEntity } from "../../entity_types/product";

export const p_5ftk5asfqa: FaireProductEntity = {
  token: "p_5ftk5asfqa",
  type: "product",
  name: "DD40344-BALLOON SHORT SLEEVE SMOCKING BODICE MIDI DRESS",
  brandToken: "b_40gau4dz8q",
  brandName: "Davi & Dani",
  imageUrl:
    "https://cdn.faire.com/fastly/9c555e4f23529d950a70407a54b2932e118aadcd672f985538294e43ef1a477e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/533bfdf61446baf2f82b0a431720006ce664ba68b66dea92f0a21521404f2eeb.jpeg",
    "https://cdn.faire.com/fastly/bf1c07ca85a6a9910c70ea01f6bbe362377d3ad21acdeba452f02baa39d3a359.jpeg",
    "https://cdn.faire.com/fastly/91c9b5fb0f4af223549a2e019f61f2a5f4e163a96cde96fc4ee20298913ea783.jpeg",
    "https://cdn.faire.com/fastly/7a142ecdbcdbf4df96628588aa5eb4ce8fcc6214d0f007ac955cda3144ac861b.jpeg",
    "https://cdn.faire.com/fastly/f86adbbe70ac51354bd0e07969196445c9300efa3f050bb970e591a372fa1e42.jpeg",
    "https://cdn.faire.com/fastly/4727e51458548f7152d84ffc2273c0bca12798b886998ed0e36fc5cbf40ec34c.jpeg",
    "https://cdn.faire.com/fastly/ee8a3ecbd22d945dfb06a2adab13a2925a9473f8969e769d920435e7c0a561f0.jpeg",
    "https://cdn.faire.com/fastly/25e02a41876ddcf9c033a3a5cf1dcead876a3eeeb57737ab31472b1a19418363.jpeg",
    "https://cdn.faire.com/fastly/c287aaffaeb931416c0392c35be941a472c9278ca1e6bebd0c307f89c03e197c.jpeg",
  ],
  priceDollars: 167.4,
  description:
    "BALLOON SHORT SLEEVE SMOCKING BODICE MIDI DRESS\r\n\r\n100%COTTON\r\n\r\nModel is wearing Small\r\nHeight: 5'10\"\r\nBust : 34\r\nWaist : 25”\r\nHips : 35”",
  tags: [],
  msrpDollars: 334.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:54.729Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
